module.exports = __webpack_public_path__ + "img/product_9.ace9ed1.webp";